
<template>
    <div :id="id" >
        <v-popover trigger="hover">
            <span class="symbol-label" ref="tooltip" :data-html="true">{{label}}</span>

            <template slot="popover">
                <span>
                    <strong>Day</strong>: Trade is active until end of the current market session or until executed within that session.
                    <br/><strong>Good Till Cancelled (GTC)</strong>: Trade is active until canceled by you or until executed.
                    <br/><strong>Extended Trading Hours (ETH)</strong>: Trade is active until end of current after-hours trading session or until executed in that session.
                </span>
            </template>
        </v-popover>

        <ul class="no_marker inline">
            <li v-for="(lbl, key) in obj">
                <input :id="'_Duration_'+key" name="duration_radio" type="radio" :checked="value == key"
                       :value="key" @click.stop="internalVal=key">
                <label :for="'_Duration_'+key"> {{lbl}}</label>
            </li>
            <!--<li>-->
                <!--<input :id="id+'_Duration_0'" name="duration_radio" type="radio" value="1" @click.stop="internalVal=1">-->
                <!--<label :for="id+'_Duration_0'">Day</label>-->
            <!--</li>-->
            <!--<li>-->
                <!--<input :id="id+'_Duration_1'" name="duration_radio" type="radio" value="2" @click.stop="internalVal=2">-->
                <!--<label :for="id+'_Duration_1'">Good Till Canceled (GTC)</label>-->
            <!--</li>-->
            <!--<li>
                <input id="PlaceOrderBox_Duration_2" name="duration_radio" type="radio" value="3" v-model="order.Duration">
                <label for="PlaceOrderBox_Duration_2">ETH</label>
            </li>
             <li>
                <input id="PlaceOrderBox_Duration_3" name="duration_radio" type="radio" value="4">
                <label for="PlaceOrderBox_Duration_3">Manual</label>
            </li> -->
        </ul>
    </div>

</template>

<script>

    import Component from 'vue-class-component'
    import {Prop, Watch, Vue, Emit} from 'vue-property-decorator'



    export default Vue.extend ({
        props:{
            value:{required:true,type:Number},
            id:{type:String, required:true},
            label:{type:String,default:"Duration*:"},
            obj:{type:Object,required:true}

        },

        components: {},
        computed:{
            internalVal: {
                get(){
                    return this.value.toString();
                },
                set(v){
                    this.$emit('input',parseInt(v));
                }

            }
        },
        methods:{
            mouseOver(){
//                this.$nextTick(function () {
//                    $("#"+this.id + " [title]").tooltip();
//                });
            },
        },

        name:"DurationRadioGroup"
        /*Duration:string=
        @Watch('Duration')
        update(newv:string,old:string){
            this.change(parseInt(newv));
        }*/
//        @Emit('input')
//        change(nevw:number){}
    })
</script>

<style scoped>

</style>